import { styled } from '@mui/material';
import { Button } from '@customink/pigment-react';

export const AuthButton = styled(Button)(({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
}));
